import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text, Icon, useTheme } from '@Sage/hoi-poi-ui';

const FunnelBar = memo(({ label, value, maxValue, color, textColor, rateLabel, rateValue }) => {
    const theme = useTheme();

    const percentage = useMemo(() => {
        if (!maxValue || maxValue === 0) return 0;
        return Math.min(100, Math.round((value / maxValue) * 100));
    }, [value, maxValue]);

    const showValueInside = percentage > 5;

    return (
        <div className="fm-funnel-bar">
            <div className="fm-funnel-bar__label">
                <Text type="body" color="neutral700">
                    {label}
                </Text>
            </div>
            <div className="fm-funnel-bar__content">
                <div className="fm-funnel-bar__track">
                    <div
                        className="fm-funnel-bar__fill"
                        style={{
                            width: `${percentage}%`,
                            backgroundColor: color,
                        }}
                    >
                        {showValueInside && (
                            <Text
                                type="body"
                                bold
                                className="fm-funnel-bar__value"
                                style={{ color: textColor }}
                            >
                                {value.toLocaleString()}
                            </Text>
                        )}
                    </div>
                    {!showValueInside && (
                        <Text
                            type="body"
                            bold
                            className="fm-funnel-bar__value--outside"
                            style={{ color: theme.colors.actionMajor[450] }}
                        >
                            {value.toLocaleString()}
                        </Text>
                    )}
                </div>
                {rateLabel && rateValue !== undefined && (
                    <div className="fm-funnel-bar__rate">
                        <div className="fm-funnel-bar__rate-badge">
                            <Icon
                                name="arrowDropDownRaw"
                                size="small"
                                color={theme.colors.actionMinor[550]}
                            />
                            <Text type="caption" color={theme.colors.actionMinor[550]}>
                                {rateLabel}:
                            </Text>
                            <Text type="caption" bold color={theme.colors.actionMinor[550]}>
                                {rateValue}%
                            </Text>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

FunnelBar.displayName = 'FunnelBar';

FunnelBar.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    textColor: PropTypes.string,
    rateLabel: PropTypes.string,
    rateValue: PropTypes.number,
};

export default FunnelBar;
